import React from 'react';
import CookieConsent from 'react-cookie-consent';
import PropTypes from 'prop-types';

function AlertaCookie({ cookieName, onAccept }) {
  const linkCookie =
    'https://drive.google.com/file/d/1fQZDM7Y3AjJYbvswHVnrX-C83pbdX751/preview?usp=sharing';
  const linkPrivacidade =
    'https://drive.google.com/file/d/1hM7Cg1uEcI1NN8qLMh8bAdcBobA0HSCz/preview?usp=sharing';

  return (
    <CookieConsent
      cookieName={cookieName}
      buttonStyle={{
        backgroundColor: '#656668',
        color: '#fff',
        borderRadius: '2px',
        width: '144px',
      }}
      enableDeclineButton
      declineButtonText="Negar"
      declineButtonStyle={{
        border: '1px solid #979797',
        borderRadius: '2px',
        color: '#000000',
        background: 'transparent',
        width: '144px',
      }}
      buttonText="Estou ciente"
      onAccept={onAccept}
      onDecline={() => {
        localStorage.clear();
      }}
      style={{
        background: '#fff',
        color: '#656668',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '21px',
        borderLeft: '6px solid #656668',
        alignItems: 'center',
      }}
    >
      <h3>Alerta de Cookies</h3>
      Este site usa cookies{' '}
      <a href={linkCookie} target="_blank" rel="noreferrer">
        (Ver política de cookies)
      </a>{' '}
      para mapear o uso e melhorar a experiência do usuário.
      <br />
      Ao continuar utilizando, o usuário está ciente das implicações e
      compartilhamento de dados.{' '}
      <a href={linkPrivacidade} target="_blank" rel="noreferrer">
        Ver política de privacidade
      </a>
    </CookieConsent>
  );
}

AlertaCookie.propTypes = {
  onAccept: PropTypes.func.isRequired,
  cookieName: PropTypes.string.isRequired,
};

export default AlertaCookie;
